import React, { useEffect } from "react";
import { FeeController } from "../../../../core/config/controllers/FeeController";
import FeeModal from "./modals/FeeModal";
import { TaxController } from "../../../../core/config/controllers/TaxController";
import TaxModal from "./modals/TaxModal";
import { PlanHelper } from "../../../../core/config/helpers/PlanHelper";

export default function ValuesAndTaxes() {

    const [loading, setLoading] = React.useState(false);
    const [showModal, setShowModal] = React.useState(false);
    const [showTaxModal, setShowTaxModal] = React.useState(false);
    const [selected, setSelected] = React.useState({});
    const [fees, setFees] = React.useState([]);
    const [taxes, setTaxes] = React.useState([]);

    useEffect(()=>{
        loadFees();
        // loadTaxes();
    },[]);

    const loadFees = async () => {
        setLoading(true);
        await FeeController.List(fee => {
            console.log("Valores", fee)
            setFees(fee)
        });
        setLoading(false);
    }

    // const loadTaxes = async () => {
    //     setLoading(true);
    //     await TaxController.List(tax => setTaxes(tax));
    //     setLoading(false);
    // }

    function removeFee(fee) {
        if (window.confirm("Você tem certeza que deseja excluir este honorário?")) {
            FeeController.Delete(fee.id);
            setFees(fees.filter(f => f.id !== fee.id));
        }
    }

    // function removeTax(tax) {
    //     if (window.confirm("Você tem certeza que deseja excluir este honorário?")) {
    //         TaxController.Delete(tax.id, () => {
    //             setTaxes(taxes.filter(f => f.id !== tax.id));
    //         });
    //     }
    // }

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
            {/* Honorários */}
            <div className="block block-rounded block-bordered">
                <div className="block-header">
                    <h2 className="block-title">Honorários</h2>
                    <div className="block-options">
                        <button className="btn btn-dual" title="Adicionar Honorário" onClick={() => setShowModal(true)}>
                            <i className="si si-plus" /> Adicionar Honorário
                        </button>
                    </div>
                </div>
                <div className="block-content">
                    <table className="block-table table table-striped table-vcenter">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Valor</th>
                                <th>Ciclo de cobrança</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {fees && fees.map((fee, index) => (
                                <tr key={index}>
                                    <td>{fee.name}</td>
                                    <td>{fee.price}</td>
                                    <td>{PlanHelper.Translate(fee.billing_cycle)}</td>
                                    <td>
                                        <button title="Editar" className="btn btn-dual" onClick={() => setSelected(fee) | setShowModal(true)}>
                                            <i className="far fa-edit"/>
                                        </button>
                                        <button title="Excluir" className="btn btn-dual" onClick={() => removeFee(fee)}>
                                            <i className="si si-close"/>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Impostos */}
            {/* <div className="block block-rounded block-bordered">
                <div className="block-header">
                    <h2 className="block-title">Impostos</h2>
                    <div className="block-options">
                        <button className="btn btn-dual" title="Adicionar Imposto" onClick={() => setShowTaxModal(true)}>
                            <i className="si si-plus" /> Adicionar Imposto
                        </button>
                    </div>
                </div>
                <div className="block-content">
                    <table className="block-table table table-striped table-vcenter">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Valor (%)</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {taxes && taxes.map((fee, index) => (
                                <tr key={index}>
                                    <td>{fee.name}</td>
                                    <td>{fee.value}%</td>
                                    <td>
                                        <button title="Editar" className="btn btn-dual" onClick={() => setSelected(fee) | setShowTaxModal(true)}>
                                            <i className="far fa-edit"/>
                                        </button>
                                        <button title="Excluir" className="btn btn-dual" onClick={() => removeTax(fee)}>
                                            <i className="si si-close"/>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div> */}
            <FeeModal
                infos={selected}
                show={showModal}
                onHide={() => {
                    setSelected({});
                    setShowModal(false);
                    loadFees();
                }}
            />
            {/* <TaxModal
                infos={selected}
                show={showTaxModal}
                onHide={() => {
                    setSelected({});
                    setShowTaxModal(false);
                    loadTaxes();
                }}
            /> */}
        </div>
    )
}